<template>
  <div class="privateBoard_page">
    <div class="top_nav">
      <div class="top_nav_item"
           v-for="(item,index) in nav_list"
           :key="index"
           :style="{'backgroundColor':activeIndex == index?'#DE1F26':'','borderRadius':activeIndex == index && index==0?'10px 0  0 10px':activeIndex == index && index==3?'0 10px 10px 0':''}"
           @click="itemClick(index)">
        <div class="index"
             :style="{'color':activeIndex == index?'#fff':'#333333'}">0{{index+1}}</div>
        <div class="content"
             :style="{'borderLeft':  activeIndex == index?'2px solid #fff':'2px solid #333'}">
          <div class="title"
               :style="{'color':activeIndex == index?'#fff':'#333333'}">{{item.title}}</div>
          <div :style="{'color':activeIndex == index?'#fff':'#999'}">{{item.content}}</div>
        </div>
        <div class="bottom"
             v-if="activeIndex == index"> <i style="color:#DE1F26"
             class="el-icon-caret-bottom"></i> </div>
      </div>
    </div>
    <div class="privateBoard_content">
      <transition name="el-zoom-in-center">
        <!-- <div v-show="show2" class="transition-box">.el-zoom-in-center</div> -->
        <div class="two transition-box">
          <div class="scee">
          </div>
          <div class="two_box">
            <div class="content_text"> <span>{{nav_list[activeIndex].content_text}}</span> <br> ({{nav_list[activeIndex].content_fu_text}}) </div>
          </div>
          <!-- 1 -->
          <div class="oneround">
            <div class="round">{{nav_list[activeIndex].one_text}}</div>
          </div>
          <!-- 2 -->
          <div class="round tworound">{{nav_list[activeIndex].two_text}}</div>
          <!-- 3 -->
          <div class="round threeround">{{nav_list[activeIndex].three_text}}</div>
        </div>
      </transition>

      <div class="privateBoard_content_right">
        <div class="title"
             style="font-size:24px">
          {{nav_list[activeIndex].right_title}}
        </div>
        <div class="title"
             style="font-size:50px;margin: 30px 0 35px 0;">
          {{nav_list[activeIndex].right_content}}
        </div>
        <div class="flexStart">
          <div>{{nav_list[activeIndex].label_title}}：</div>
          <div :class="itemIndex == item?'cyItemAcatie':'cyItem'"
               v-for="item in nav_list[activeIndex].labelList"
               @mouseenter="mouseover(item)"
               @mouseleave="mouseout"
               :key="item">{{item}}</div>
        </div>
        <div class="flexStart">
          <div class="img"
               v-for="item in nav_list[activeIndex].imgList"
               :key="$imgUrl + item">
            <el-image style="width:100%;height:100%"
                      class="dong"
                      :src="$imgUrl + item"></el-image>
          </div>
        </div>
      </div>
    </div>
    <div class="flexCenter"
         style="margin-top:60px">
      <el-button round
                 style="width:200px;"
                 type="danger"
                 @click="toForm">申请加入私董会</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: 0,
      itemIndex: 1,
      nav_list: [
        { title: '创业课程', content: '掌握本质规律做老板定位', content_text: '老板', content_fu_text: '创业者', one_text: '企业家', two_text: '教育家', three_text: '投资家', right_title: '帮助创业者构建  创业思维模式避免低水平重复', right_content: '本色做人  角色做事', label_title: '创业者三堂大课', labelList: ['战略创新', '组织管理', '个人成长'], imgList: ['Bosscircle/CY_img.png', 'Bosscircle/CY_img2.png', 'Bosscircle/CY_img3.png'] },
        { title: '标杆案例', content: '学习标杆成为更好的自己', content_text: '标杆', content_fu_text: '成功者', one_text: '国内外', two_text: '行业内', three_text: '行业外', right_title: '理解创业这件事  还原创业的底层逻辑', right_content: '取其精华  少走弯路', label_title: '活动主题', labelList: ['走进标杆', '拆除标杆', '企业家分享'], imgList: ['Bosscircle/BG_img.png', 'Bosscircle/BG_img2.png', 'Bosscircle/BG_img3.png'] },
        { title: '资源整合', content: '终端零售终局在供应链能力', content_text: '资源', content_fu_text: '服务者', one_text: '人脉', two_text: '商品', three_text: '项目', right_title: '整合优质上游厂家资源针对性解决爆品及供应链问题', right_content: '商品为王  降低成本', label_title: '活动主题', labelList: ['项目联投', '资源整合', '企业家分享'], imgList: ['Bosscircle/ZY_img.png', 'Bosscircle/ZY_img2.png', 'Bosscircle/ZY_img3.png'] },
        { title: '行业观察', content: '有效认知  节省时间', content_text: '讲师', content_fu_text: '分享者', one_text: '实战企业家', two_text: '各领域专家', three_text: '学院专家', right_title: '行业观察  行业动态  产业变化等形式  共享认知  提升经营技能', right_content: '有效认知  节省时间', label_title: '活动主题', labelList: ['趋势解读', '提升认知', '行业变革'], imgList: ['Bosscircle/HY_img.png', 'Bosscircle/HY_img2.png', 'Bosscircle/HY_img3.png'] },
      ],

    }
  },
  methods: {
    itemClick (index) {
      this.activeIndex = index;
    },
    toForm () {
      this.$router.push('/Form?type=19')
    },
    mouseover (index) {
      console.log(index)
      this.itemIndex = index;
    },
    mouseout () {
      this.itemIndex = -1;
    }
  }
}
</script>
<style lang="less" scoped>
.privateBoard_page {
  width: 100%;
  color: #333;
  .privateBoard_content {
    margin-top: 77px;
    display: flex;
    padding: 0 30px;
    box-sizing: border-box;
    .two {
      width: 367px;
      height: 367px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      // background-color: green;
      .round {
        background-color: #ffe0e0;
        border-radius: 50%;
        width: 92px;
        height: 92px;
        color: #333333;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        // line-height: 92px;
      }
      .oneround {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: center;
      }
      .tworound {
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .threeround {
        position: absolute;
        right: 0;
        bottom: 0;
      }
      .two_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        text-align: center;
        .content_text {
          padding: 25px 0 0 0;
          font-size: 24px;
          font-weight: bold;
          span {
            font-size: 50px;
          }
        }
      }
      .scee {
        width: 0;
        height: 0;
        border-left: 144px solid transparent;
        border-right: 144px solid transparent;
        border-bottom: 248px solid #de1f26;
      }
    }
    .privateBoard_content_right {
      flex: 1;
      color: #fff;
      margin-left: 130px;
      .title {
        font-size: 24px;
      }
      .img {
        flex: 1;
        margin-right: 11px;
        margin-top: 30px;
        height: 120px;
        overflow: hidden;
        background-color: #eee;
        // .dong {
        //   overflow: hidden;
        // }
        .dong:hover {
          transition: all 3s;
          transform: scale(1.4);
        }
      }
      .cyItem {
        display: inline-block;
        padding: 5px 18px;
        border-radius: 16px;
        font-size: 14px;
        margin-right: 20px;
        border: 1px solid #fff;
        color: #fff;
        box-sizing: border-box;
        font-weight: bold;
      }
      .cyItemAcatie {
        display: inline-block;
        padding: 5px 18px;
        font-size: 14px;
        border-radius: 16px;
        margin-right: 20px;
        font-weight: bold;
        border: 1px solid #fff;
        box-sizing: border-box;
        background-color: #de1f26;
      }
    }
  }
  .top_nav {
    display: flex;
    width: 100%;
    height: 124px;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 10px;
    .top_nav_item {
      text-align: center;
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 38px 15px 38px 15px;
      box-sizing: border-box;
      position: relative;
      cursor: pointer;
      .bottom {
        bottom: -22px;
        left: 0;
        width: 100%;
        position: absolute;
        font-size: 30px;
      }
      .index {
        font-size: 50px;
        font-weight: bold;
        // font-style: italic;
      }
      .content {
        flex: 1;
        margin-left: 15px;
        padding-left: 15px;
        border-left: 2px solid #333;
        font-size: 14px;
        color: #999;
        .title {
          font-size: 24px;
          color: #333;
        }
      }
    }
  }
}
</style>